import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from '@nuxtjs/composition-api'
import { useRestaurantModel } from '@entities/restaurant'
import { Cookie } from '@shared/lib'
import { usePreloaderModel } from '@shared/model/preloader'
import { usePrivacyPolicyModel } from '@features/privacy-policy'
import { privacyPolicy } from '@widgets/privacy-policy'
import { useMetaModel } from '@entities/meta'
import { initCallPrimeHill, useLoyaltyModel } from '@entities/loyalty'
import { AppButton } from '@shared/ui'
import { useOrderModel } from '@entities/order'


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberEntry',
  emits: [
  'setBonusesWrittenOff',
  'setTotalNumberBonuses',
  'setTypeWriteOffBonuses',
  'changeActiveModalBonus',
  'setSumDiscountPrimeHill',
  'callYandexMetricGoal'
],
  setup(__props, { emit: emits }) {

const restaurantModel = useRestaurantModel()
const preloaderModel = usePreloaderModel()
const metaModel = useMetaModel()
const loyaltyModel = useLoyaltyModel()
const orderModel = useOrderModel()

// Emits


const privacyPolicyModel = usePrivacyPolicyModel()
const VERIFIED_PHONE_COOKIE = 'primeHillCodeVerifiedPhone'
const DEFAULT_PHONE_ERROR = 'Номер не найден, обратитесь к официанту'

const isVerificationOn = (value: unknown): boolean => {
  if (value === true || value === 1) {
    return true
  }
  if (value === false || value === 0 || value === null || value === undefined) {
    return false
  }

  return ['ON', 'TRUE', '1', 'YES', 'Y'].includes(String(value).trim().toUpperCase())
}

// Data
const phone = ref<string>('')
const errorPhone = ref<boolean>(false)
const errorMessage = ref<string>(DEFAULT_PHONE_ERROR)
const butttonDisabled = ref<boolean>(true)

// Watch
watch(phone, (newVal, oldVal) => {
  if (errorPhone.value && newVal !== oldVal) {
    errorPhone.value = false
    errorMessage.value = DEFAULT_PHONE_ERROR
  }
  const phoneResult = phone.value.replace(/\D/g, '')
  if (phoneResult.length === 11) {
    butttonDisabled.value = false
  } else {
    butttonDisabled.value = true
  }
})

// Methods
const sendPhone = async () => {
  preloaderModel.status = true
  const tel = phone.value.replace(/\D/g, '')
  const session = metaModel.session !== null ? parseFloat(metaModel.session) : metaModel.session
  const payload = {
    tel,
    session: session ? Number(session) : 0
  }
  const loyaltyCode = orderModel.orderData?.global_system_loyalty?.code
  if (loyaltyCode === 'prime_hill') {
    const isVerificationEnabled =
      isVerificationOn(orderModel.orderData?.global_system_loyalty?.verification) ||
      isVerificationOn(loyaltyModel.verification)
    const isAlreadyVerifiedOnDevice = String(Cookie.get(VERIFIED_PHONE_COOKIE) ?? '') === tel
    const shouldShowCodeStep = isVerificationEnabled && !isAlreadyVerifiedOnDevice

    if (shouldShowCodeStep) {
      const shopId = Number(orderModel.orderData?.settings?.shop_id)
      if (!shopId || tel.length !== 11) {
        errorMessage.value = DEFAULT_PHONE_ERROR
        errorPhone.value = true
        preloaderModel.status = false
        return
      }
      try {
        const initOk = await initCallPrimeHill(shopId, tel)
        if (!initOk) {
          errorMessage.value = DEFAULT_PHONE_ERROR
          errorPhone.value = true
          preloaderModel.status = false
          return
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
        errorMessage.value = DEFAULT_PHONE_ERROR
        errorPhone.value = true
        preloaderModel.status = false
        return
      }
      Cookie.set('primeHillPhone', tel, 90)
      Cookie.set('primeHillReminder', String(Date.now()), 90)
      Cookie.set('primeHillWasGreeting', restaurantModel.code, 1)
      loyaltyModel.setCurrentPhone(tel)
      loyaltyModel.setVerifiedPhone(String(Cookie.get(VERIFIED_PHONE_COOKIE) ?? ''))
      emits('changeActiveModalBonus', 'enteringCode')
      emits('callYandexMetricGoal', 'PHSendPhone')
      preloaderModel.status = false
      return
    }

    loyaltyModel.fetchUserPrimeHill(payload).then((res: boolean) => {
      if (res) {
        Cookie.set('primeHillPhone', tel, 90)
        Cookie.set('primeHillReminder', String(Date.now()), 90)
        Cookie.set('primeHillWasGreeting', restaurantModel.code, 1)
        loyaltyModel.setCurrentPhone(tel)
        loyaltyModel.setVerifiedPhone(String(Cookie.get(VERIFIED_PHONE_COOKIE) ?? ''))

        emits('changeActiveModalBonus', 'writeOffBonuses')
        emits('callYandexMetricGoal', 'PHSendPhone')
        preloaderModel.status = false
      } else {
        errorMessage.value = DEFAULT_PHONE_ERROR
        errorPhone.value = true
        preloaderModel.status = false
      }
    })
  } else if (loyaltyCode === 'iiko_card') {
    loyaltyModel.fetchUserIikoCard(payload).then((res: boolean) => {
      if (res) {
        const isVerificationEnabled =
          isVerificationOn(loyaltyModel.verification) ||
          isVerificationOn(orderModel.orderData?.global_system_loyalty?.verification)
        const isAlreadyVerifiedOnDevice = String(Cookie.get(VERIFIED_PHONE_COOKIE) ?? '') === tel
        const shouldShowCodeStep = isVerificationEnabled && !isAlreadyVerifiedOnDevice
        Cookie.set('primeHillPhone', tel, 90)
        Cookie.set('primeHillReminder', String(Date.now()), 90)
        Cookie.set('primeHillWasGreeting', restaurantModel.code, 1)
        loyaltyModel.setCurrentPhone(tel)
        loyaltyModel.setVerifiedPhone(String(Cookie.get(VERIFIED_PHONE_COOKIE) ?? ''))
        emits('changeActiveModalBonus', shouldShowCodeStep ? 'enteringCode' : 'writeOffBonuses')
        emits('callYandexMetricGoal', 'PHSendPhone')
        preloaderModel.status = false
      } else {
        errorMessage.value = DEFAULT_PHONE_ERROR
        errorPhone.value = true
        preloaderModel.status = false
      }
    })
  }
}

return { __sfc: true,restaurantModel, preloaderModel, metaModel, loyaltyModel, orderModel, emits, privacyPolicyModel, VERIFIED_PHONE_COOKIE, DEFAULT_PHONE_ERROR, isVerificationOn, phone, errorPhone, errorMessage, butttonDisabled, sendPhone, privacyPolicy, AppButton }
}

})